import type { FC } from 'react';
import { CabinetTitlePage } from 'components/layout';
import { AddFacebookPageForm } from 'features/cabinet';
import { Guard, usePermissionGuard } from 'features/login';

const AddFacebookPagePage: FC = () => {
  const { accessToAddFacebookpage } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToAddFacebookpage}>
      <CabinetTitlePage
        title={'Facebook Pages'}
        goBack={'/cabinet/facebook/facebook-pages'}
      />
      <AddFacebookPageForm />
    </Guard>
  );
};

export default AddFacebookPagePage;
